import React from 'react';
import { Button } from '../../components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogFooter,
} from '../../components/ui/dialog';

// Non-member job modal image
const NON_MEMBER_IMAGE = "https://customer-assets.emergentagent.com/job_ba288840-867e-4483-82f4-5d28fd248d68/artifacts/plfzkycj_ChatGPT%20Image%20Feb%2020%2C%202026%2C%2005_49_55%20PM.png";

export const JobDetailNonMemberDialog = ({ open, onOpenChange, onBrowseMember }) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <div className="space-y-4">
          {/* Image */}
          <div className="flex justify-center">
            <img
              src={NON_MEMBER_IMAGE}
              alt="This job is posted by a non-member"
              className="w-full max-w-xs rounded-xl shadow-md"
            />
          </div>

          {/* Additional Message */}
          <div className="text-center space-y-2">
            <p className="text-gray-600">
              Check out jobs from our <strong className="text-primary">member employers</strong> for a complete application experience!
            </p>
          </div>
        </div>

        <DialogFooter className="flex-col sm:flex-row gap-2 mt-4">
          <Button
            variant="outline"
            onClick={() => onOpenChange(false)}
            className="flex-1"
          >
            Close
          </Button>
          <Button
            onClick={onBrowseMember}
            className="flex-1 bg-primary hover:bg-primary-hover text-white"
            data-testid="browse-member-jobs-btn"
          >
            Browse Member Jobs
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
